import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_PARAMS_SCHEMA_LITERAL = {
    title: 'Schéma Params',
    description: 'Décrit params',
    version: 2,
    keyCompression: false,
    primaryKey: 'CBMARQ',
    type: 'object',
    properties: {
        CBMARQ: { type: 'string', maxLength : 2 },
        DATE_SYNCHRO: { type: ['string', 'null'] },
        DATE_SYNCHRO_RUNNER: { type: ['string', 'null'] },
        DISPLAY_DEVICE_MESSAGES: { type: ['string', 'null'] },
    },
    required: [ 'CBMARQ' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_PARAMS_SCHEMA_LITERAL);
export type RxPParamsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_PARAMS_SCHEMA: RxJsonSchema<RxPParamsDocumentType> = P_PARAMS_SCHEMA_LITERAL;
